"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAsyncFunction = void 0;
const isFunction_1 = __importDefault(require("./isFunction"));
/**
 * check given object is async function or not
 *
 * @since 5.22.0
 * @category Lang
 * @param obj
 * @returns
 */
function isAsyncFunction(obj) {
    if (!(0, isFunction_1.default)(obj)) {
        return false;
    }
    return obj[Symbol.toStringTag] === "AsyncFunction";
}
exports.isAsyncFunction = isAsyncFunction;
exports.default = isAsyncFunction;
